import { render, staticRenderFns } from "./UserSelfReportSvg.vue?vue&type=template&id=b0b10784&"
import script from "./UserSelfReportSvg.vue?vue&type=script&lang=js&"
export * from "./UserSelfReportSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports